module.exports = "https://static.zego.com/_next/static/images/FixedIcon-65554a9b21d3990ad9a61d0b5db0750e.svg";